import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { amendmentKeys } from '../queries/amendmentQueryKeys'
import { financialStatementsKeys } from '../../financialStatements/queries/financialStatementsQueryKeys'
import { deleteAmendment } from '../service/amendmentService'

interface DeleteAmendmentParams {
  id: number
  accountCode: number
  counterPartAccountCode?: number
}

export const useDeleteAmendment = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { message } = App.useApp()

  return useMutation({
    mutationFn: (params: DeleteAmendmentParams) => deleteAmendment(companyId, params.id),
    mutationKey: ['amendment', 'delete'],
    onSuccess: () => {
      message.success(t('messages:deleteSuccess', 'Success'))
      queryClient.invalidateQueries({ queryKey: amendmentKeys.all })
      queryClient.invalidateQueries({ queryKey: financialStatementsKeys.statements() })
    }
  })
}
